import { useCallback, useEffect, useState } from 'react';

type ScreenStatusType = 'play' | 'error' | 'restricted' | 'blank' | 'other';

export const useScreenStatus = ({ delay = 4000 }: { delay?: number }) => {
  const [status, setStatus] = useState<ScreenStatusType | null>(null);

  const detectStatus = useCallback((): ScreenStatusType => {
    const gameSelector = '[data-ui="game-panel"]';
    const loaderSelector = '[data-ui="preloader"]';
    const root = document.getElementById('root');
    const hasGameUI = Boolean(document.querySelector(gameSelector));
    const hasPreloader = Boolean(document.querySelector(loaderSelector));

    if (!root || root.textContent?.trim() === '') return 'blank';

    if (hasPreloader) return 'error';

    if (hasGameUI) return 'play';

    return 'other';
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStatus(detectStatus());
    }, delay);

    return () => clearTimeout(timer);
  }, [detectStatus, delay]);

  return status;
};
